export const LOCALES = ["es-ES", "en-US"]

export const DEFAULT_LOCALE = "es-ES"

export const MARKETING_FIELDS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
]

export const COUNTRY_COOKIE_NAME = "country"

export const DEFAULT_COUNTRY_CODE = "ES"
